import { render, staticRenderFns } from "./FilterSort.vue?vue&type=template&id=28930b78&scoped=true&"
import script from "./FilterSort.vue?vue&type=script&lang=js&"
export * from "./FilterSort.vue?vue&type=script&lang=js&"
import style0 from "./FilterSort.vue?vue&type=style&index=0&id=28930b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28930b78",
  null
  
)

export default component.exports